import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  Box,
  CircularProgress,
  Typography,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { DocumentService } from '../../../services/documentsServices'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { useParams } from 'react-router-dom'
import { GetApp as GetAppIcon, Visibility } from '@mui/icons-material'
import { fileServices } from '../../../services/fileServices'
import FileViewer from '../../../components/Dashboard/PreviewComponent/components/FileViewer'

const GenerateDocumentsDialog = ({
  isGenerateDocumentDialogue,
  setIsGenerateDocumentDialogue,
  processTemplateId,
}) => {
  const { user } = useAuthContext()
  const { process_id: processId, activity_template_id: activityTemplateId } = useParams()

  const [generatedDoc, setGeneratedDoc] = useState([])
  const [loading, setLoading] = useState(new Set())
  const [previewFileKey, setPreviewFileKey] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const generateDocument = async () => {
    setIsLoading(true)
    try {
      const doc = await DocumentService.manuallyGenerateDoc(
        user,
        processId
      )
      setGeneratedDoc(doc)
    } catch (error) {
      console.error('Error generating document:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const doc = await DocumentService.getManuallyGenerateDoc(
          user,
          processId,
          activityTemplateId
        )
        setGeneratedDoc(doc)
      } catch (error) {
        console.error('Error fetching generated document:', error)
      }
    }

    fetchData()
  }, [user, processId, activityTemplateId])


  const downloadFile = async (fileName, index) => {
    setLoading((prev) => new Set([...prev, index]))
    try {
      await fileServices.downloadFile(user, fileName, 'documents_for_template')
    } catch (error) {
      console.error('Error downloading file:', error)
    } finally {
      setLoading((prev) => {
        const updated = new Set(prev)
        updated.delete(index)
        return updated
      })
    }
  }

  return (
    <>
      <Dialog
        open={isGenerateDocumentDialogue && !previewFileKey}
        onClose={() => setIsGenerateDocumentDialogue(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Manually Generate Document</DialogTitle>
        <DialogContent>
          {isLoading ? (
            <CircularProgress color="info" size={'25px'} />
          ) : generatedDoc && generatedDoc.length > 0 ? (
            generatedDoc.map((doc, index) => (
              <Box
                key={index}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Typography>{doc.document_template_name}</Typography>

                <span>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setPreviewFileKey(`documents_for_template/${doc.key}`)
                    }}
                  >
                    <Visibility size="small" />
                  </IconButton>

                  <IconButton size="small" download onClick={() => downloadFile(doc.key, index)}>
                    {loading.has(index) ? (
                      <CircularProgress color="info" size={'25px'} />
                    ) : (
                      <GetAppIcon color="info" size="small" />
                    )}
                  </IconButton>
                </span>
              </Box>
            ))
          ) : (
            <Typography variant="p">No document available</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setIsGenerateDocumentDialogue(false)}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
          <Button onClick={generateDocument} color="primary" variant="contained">
            Generate
          </Button>
        </DialogActions>
      </Dialog>
      <FileViewer
        open={!!previewFileKey}
        onClose={() => {
          setPreviewFileKey(null)
        }}
        fileKey={previewFileKey}
        user={user}
        onDownload={() => {
          if (previewFileKey) {
            const keyOnly = previewFileKey.split('/').pop()
            const fileIndex = generatedDoc.findIndex((f) => f.key === keyOnly)
            downloadFile(keyOnly, fileIndex !== -1 ? fileIndex : 0)
          }
        }}
      />
    </>
  )
}
export default GenerateDocumentsDialog
